import { showLoginFormLoader } from "./loaderActions";
import { panels } from "../../variables";
import {
  SET_DEFAULT_VALUE,
  USER_AUTHENTICATION_FAILED,
  USER_AUTHENTICATION_SUCCESS,
} from "./types";
import { resetPanelsState, setActivePanel } from "./panelsActions";
import { checkErrorStatusAndExecuteCallback, parseSnils } from "../../utils";
import { setSnils } from "./snilsActions";
import { startSecondStepLoading } from "./regionAndMedicalOrganisationActions";
import store from "../store";
import { removeAccessTokenCookie } from "../../services/user";
import { setMetrics } from "../../helpers/metrics";
import { HealthCheckEvents } from "../../api/types";
import Api from "../../api";

export const logout = () => (dispatch) => {
  removeAccessTokenCookie();
  dispatch(resetPanelsState());
};

export const userAuthenticationStarted = (login, password, type) => (
  dispatch
) => {
  const healthCheckInstance = Api.healthCheckFor(
    HealthCheckEvents.authorization
  );

  dispatch(setDefaultValue());
  dispatch(showLoginFormLoader());
  if (type === "SNILS") {
    login = parseSnils(login);
    dispatch(setSnils(login));
  }

  const data = {
    type,
    login,
    password,
    instanceId:
      "eyJvc190eXBlIjoiaW9zIiwicGVyc2lzdGVudCI6eyJkZXZpY2VfaWQiOiIyNDYwMEI0Mi1EQjk5LTQ5ODMtQTQxNi05M0NDMzI0MzVFQUMifSwiYXBwX25hbWUiOiJnb3N1c2x1Z2lfbW9iIiwicm5kX2lkIjoiNUE3RDMyODEtMzVGQi00QjBFLUI3MTgtM0UxOEUzQjEyRTMzIiwib3NfdmVyc2lvbiI6IjEzLjMiLCJwaG9uZV9tb2RlbCI6ImlQaG9uZSJ9",
    terminalName: "iPhone 11 Pro",
    terminalType: "iPhone",
  };

  return Api.instance
    .post("shared/v1/login", data)
    .then((res) => {
      // @todo. Убрать, когда сервер начнет возвращать JSON вместо HTML, в случае неверного логина или пароля
      if (res.status === 500) {
        return {
          msg: "Введено неверное имя пользователя или пароль",
        };
      }

      return res.data;
    })
    .then((body) => {
      const {
        access_token,
        oid,
        sessionId,
        refresh_token,
        token_type,
        expires_in,
      } = body;

      // checkBodyAndThrowError(body);

      // setAccessTokenCookie({
      //   accessToken: access_token,
      //   oid,
      //   sessionId,
      //   refreshToken: refresh_token,
      //   tokenType: token_type,
      //   expiresIn: expires_in,
      // });

      dispatch(startSecondStepLoading());
      dispatch(
        userAuthenticationSuccess(
          access_token,
          oid,
          sessionId,
          refresh_token,
          token_type,
          expires_in
        )
      );

      healthCheckInstance.sendSuccess();

      return body;
    })
    .catch((error) => {
      setMetrics("reachGoal", "OldHealth.AuthorizationError");
      dispatch(userAuthenticationFailed(error.msg || error.message));
      checkErrorStatusAndExecuteCallback(error, () =>
        dispatch(setActivePanel(panels.error))
      );
      healthCheckInstance.sendFailure({ browserError: error.message });
      throw error.msg || error.message;
    });
};

const checkBodyAndThrowError = (body) => {
  if (body.msg && body.msg.includes("User account not found")) {
    throw new Error("Данный аккаунт не найден");
  } else if (body.msg && body.msg.includes("User login has wrong structure")) {
    throw new Error("Неверный логин");
  } else if (body.msg && body.msg.includes("Login or password incorrect")) {
    throw new Error("Неверный логин или пароль");
  } else if (body.msg) {
    throw new Error(body.msg);
  }
};
export const userAuthenticationSuccess = (
  accessToken,
  oid,
  sessionId,
  refreshToken,
  tokenType,
  expiresIn
) => {
  return {
    type: USER_AUTHENTICATION_SUCCESS,
    payload: {
      accessToken,
      oid,
      sessionId,
      refreshToken,
      tokenType,
      expiresIn,
    },
  };
};

export const userAuthenticationFailed = (e) => {
  return {
    type: USER_AUTHENTICATION_FAILED,
    payload: {
      error: e,
    },
  };
};

export const setDefaultValue = () => {
  return {
    type: SET_DEFAULT_VALUE,
  };
};
